import { apiClient } from '../lib/api';
import { ENDPOINTS } from './endpoints';

export interface PublicUserProfile {
  id: string;
  fullName: string | null;
  initials: string;
  userType: string;
}

export async function getPublicProfile(userId: string): Promise<PublicUserProfile> {
  const res = await apiClient.get<PublicUserProfile>(ENDPOINTS.users.publicProfile(userId));
  return res.data;
}
